export const brandTokens = {
  ink: "#17201e",
  inkStrong: "#111a18",
  surface: "#ffffff",
  canvas: "#f3f5f4",
  line: "#e2e7e5",
  muted: "#6e7b78",
  orange: "#ff7a00",
  orangeDark: "#d95e08",
  green: "#147a5f",
  greenSoft: "#e8f7f2",
  red: "#c94444",
  redSoft: "#fff0ef",
  blue: "#2b70cb",
  blueSoft: "#edf5ff",
  violet: "#7657d7",
  violetSoft: "#f1edff",
  darkInk: "#f5faf8",
  darkSurface: "#17211e",
  darkCanvas: "#0c1210",
  darkPanel: "#111a18",
  darkLine: "#2a3834",
  darkMuted: "#a7b6b1",
} as const;

export const typographyTokens = {
  fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  baseSize: "16px",
  baseLineHeight: 1.45,
  displaySize: "34px",
  titleSize: "24px",
  sectionTitleSize: "20px",
  bodySize: "16px",
  controlSize: "15px",
  metaSize: "14px",
  captionSize: "12px",
} as const;
